// src/components/AISection.jsx
import React from 'react';
import { useTranslation } from '../context/TranslationContext';

export default function AISection() {
  const { t } = useTranslation();
  return (
    <section className="h-96 parallax flex items-center justify-center ai-section">
        <div className="text-center text-white bg-black bg-opacity-50 py-6 px-8 rounded-lg animate-fade-in">
            <h2 className="text-4xl font-bold" >{t('ai_section_title')}</h2>
            <p className="text-lg mt-4" >{t('ai_section_description')}</p>
        </div>
    </section>
  );
}
